import { render, staticRenderFns } from "./OrdersInbox.vue?vue&type=template&id=20088c19&scoped=true&"
import script from "./OrdersInbox.vue?vue&type=script&lang=js&"
export * from "./OrdersInbox.vue?vue&type=script&lang=js&"
import style0 from "./OrdersInbox.vue?vue&type=style&index=0&id=20088c19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20088c19",
  null
  
)

export default component.exports